const localFascia = "returns-jdsportsuk.rome.support";
export const hostname = window.location.host.includes("localhost")? localFascia : window.location.hostname;
const config = process.env.REACT_APP_ENV === 'prod'?require("./store-data.json"):require("./uat-store-data.json");
export let store = config[hostname];
